import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import { normalizeReportsCategoriesPayload } from '../../../helpers/normalizeReportsAdminResponse';

const initialState = {
  loading: false,
  breakdown: [],
  series: [],
  error: '',
};

export const fetchReportsCategories = createAsyncThunk(
  'categoryReport/fetchReportsCategories',
  (params = {}) =>
    ReportService.getReportsCategories(
      normalizeReportParams({ ...params, format: 'json' })
    ).then((res) => res)
);

const categoryReportSlice = createSlice({
  name: 'categoryReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchReportsCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchReportsCategories.fulfilled, (state, action) => {
      const n = normalizeReportsCategoriesPayload(action.payload);
      state.loading = false;
      state.breakdown = n.breakdown;
      state.series = n.series;
      state.error = '';
    });
    builder.addCase(fetchReportsCategories.rejected, (state, action) => {
      state.loading = false;
      state.breakdown = [];
      state.series = [];
      state.error = action.error.message;
    });
  },
  reducers: {
    filterReportProduct() {},
  },
});

export const { filterReportProduct } = categoryReportSlice.actions;
export default categoryReportSlice.reducer;
